<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" depressed @click="$forceUpdate()">
        <template v-if="notifications.length > 0">
          <v-badge color="red" left>
            <template v-slot:badge>
              <span>{{ notifications.length > 5 ? "5+" : notifications.length }}</span>
            </template>
            <v-icon>mdi-bell</v-icon>
          </v-badge>
          <v-icon>mdi-menu-down</v-icon>
        </template>
        <template v-else>
          <v-icon>mdi-bell</v-icon>
        </template>
      </v-btn>
    </template>

    <v-list two-line v-if="notifications.length > 0" :max-height="height * 0.92" class="notification-scroll">
      <template v-for="(notification, index) in notifications">
        <v-list-item
          ripple
          :to="(notification.route && !notification.route.startsWith('http')) ? notification.route : ''"
          :href="(notification.route && notification.route.startsWith('http')) ? notification.route : ''"
          :key="notification.date.getTime()"
        >
          <v-list-item-avatar>
            <v-icon :color="notification.type">{{ notificationIcon(notification.type) }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <template v-if="typeof notification.message === 'string'">
              <v-list-item-title overflow-x-hidden>
                {{ notification.message }}
              </v-list-item-title>
            </template>
            <template v-else>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-list-item-title overflow-x-hidden v-on="on">
                    {{ $t("error." + get_eid(notification.message.eid), replace_param(notification.message.eid, notification.message.param)) }}
                  </v-list-item-title>
                </template>
                <span>{{ $t("error." + get_eid(notification.message.eid), replace_param(notification.message.eid, notification.message.param)) }}</span>
              </v-tooltip>
              <v-list-item-subtitle>
                {{ $t("message.common.eid") }}:&nbsp;{{ notification.message.eid }}
                <template v-if="notification.message.rid">
                  ,&nbsp{{ $t("message.common.rid") }}:&nbsp;{{ notification.message.rid }}
                </template>
              </v-list-item-subtitle>
            </template>
            <v-list-item-subtitle>{{ notificationTime(notification.date) }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click.stop="$store.commit('deleteNotification', index)">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import { get_eid } from "../js/get_eid";

export default {
  name: 'notification',
  mixins: [get_eid],
  data: function(){
    return {
      module_id: "53",
      height: window.innerHeight
    };
  },
  computed: {
    ...mapGetters([
      'notifications'
    ])
  },
  methods: {
    notificationIcon: function(type){
      var icon = "mdi-information";
      switch(type){
        case "error":
          icon = "mdi-alert";
          break;
        case "warning":
          icon = "mdi-exclamation";
          break;
        case "success":
          icon = "mdi-check-circle";
          break;
        default:  // include "info"
          icon = "mdi-information";
          break;
      }
      return icon;
    },
    notificationTime: function(event_date){
      var now = new Date();
      var diff = (now.getTime() - event_date.getTime()) / 1000;
      var result = "";
      if(diff < 60){
        result = this.$i18n.tc("message.notification.second", Math.floor(diff % 60), { count: Math.floor(diff % 60) });
      }else if(diff < 3600){
        result = this.$i18n.tc("message.notification.minute", Math.floor(diff / 60), { count: Math.floor(diff / 60) });
      }else if(diff < 86400){
        result = this.$i18n.tc("message.notification.hour", Math.floor(diff / 3600), { count: Math.floor(diff / 3600) });
      }else{
        result = this.$i18n.d(date, 'short', $store.getters.langs[$i18n.locale].locale);
      }
      return result;
    },
    handleResize: function() {
      this.height = window.innerHeight;
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style scoped>
.notification-scroll {
  overflow-y: scroll;
}
</style>
